export const isBuilderPage = () => {
  return window.location.pathname === '/builder';
};
